/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_S1_TitleInputs */

const en_landing_how_s1_title = /** @type {(inputs: Landing_How_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief it`)
};

const zh_landing_how_s1_title = /** @type {(inputs: Landing_How_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写需求`)
};

/**
* | output |
* | --- |
* | "Brief it" |
*
* @param {Landing_How_S1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_how_s1_title = /** @type {((inputs?: Landing_How_S1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_S1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_how_s1_title(inputs)
	return zh_landing_how_s1_title(inputs)
});
export { landing_how_s1_title as "landing.how.s1_title" }